export default {
  address: 'Adresse *',
  'create-account-247-support': '24/7 Kundenbetreuung',
  'create-account-secure': '100% Sicher',
  'create-account-fast': 'Schnelle & einfache Abhebungen',
  'create-account-gambling-commission': 'Glücksspielkommission',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Willkommensbonus',
  'create-account-promotion-description': 'bis zu ##UPTO_AMOUNT## auf Deine erste Einzahlung',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Freispiele',
  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Bedingungen gelte.</a> Bitte spielen Sie verantwortungsbewusst. <a href="http://www.gamblingtherapy.org/de" target="_blank">www.Gamblingtherapy.org</a>',
  'create-account-success-welcome-activated': 'Willkommen bei Ursa Casino',
  'create-account-success-body-text-activated': 'Wir freuen uns, dich zu deinem Ursa Casino-Abenteuer begrüßen zu dürfen!', //l_welcome_strap
  'create-account-failure-blocked-data':
    'Entschuldigung , Sie sind von der Registrierung ausgeschlossen! Bitte wenden Sie sich an Support, wenn Sie der Meinung sind, dass Sie diesen Fehler falsch erhalten haben.',

  //need translations!
  'create-account-promotion-sign-in': 'Du hast bereits ein Konto?',
  'create-account-close': 'schließen',

  'personal-details-title': 'Registrierung',
  'personal-details-supporting-text': 'Nur 3 einfache Schritte',
  'address-details-title': 'Fast geschafft!',
  'address-details-supporting-text': 'Sehr gut, nur noch ein paar weitere Details.',
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'Das ist der letzte Schritt!',

  'username-help-text': 'Verwende bitte nur 6-20 Buchstaben oder Nummern, Kleinbuchstaben ohen Leerzeichen.',
  'password-help-text': 'Verwende wenigstens 8 Zeichen.',
  'deposit-limit-notice':
    'Möchtest Du Deine Einzahlungseinstellungen verändern? <a href="##ORIGIN_URL##/index.php?page=depositlimit" target="_blank">Einzahlungslimits</a> können jederzeit in Deinen Kontoeinstellungen festgelegt, geändert oder entfernt werden.',
  'select-your-bonus': 'Wähle Deinen Bonus aus',
  'secure-payment-notice': '100% sichere Zahlung',
  change: 'Ändern',
  'expiry-date': 'Ablaufdatum',

  'marketing-preferences-title': 'Kommunikationseinstellungen',
  'marketing-preferences-description':
    'Ursa Casino bietet seiner Spielergemeinschaft einzigartige tägliche Deals & monatliche Highlights wie Match-Boni, Bonus-Spins, Freirunden, Cashback-Angebote, Turniere, Ranglisten, Real-Life-Preise, Erlebnisse und Urlaub. Um mehr darüber zu erfahren, wählen Sie bitte unten aus:',
  'marketing-preferences-post-text': 'Sie können Ihre Kommunikationspräferenzen jederzeit im "Mein Konto"-Bereich aktualisieren.',
  'marketing-preferences-label-cross-brand': 'Ich möchte über exklusive Angebote aus Ihrem Netzwerk informiert werden.',
  'marketing-preferences-label-brand-only': 'Ich möchte nur über exklusive Angebote informiert werden.',
  'marketing-preferences-label-email': 'Ich möchte über Angebote per <strong>E-Mail </strong> informiert werden',
  'marketing-preferences-label-sms': 'Ich möchte über Angebote per <strong>SMS</strong> informiert werden',
  'marketing-preferences-label-phone-call': 'Ich möchte über Angebote per <strong>Telefon</strong> informiert werden',
  'marketing-preferences-label-post': 'Ich möchte über Angebote per <strong>Post</strong> informiert werden',

  'marketing-preferences-unified-description':
    'Verpassen Sie nicht die neuesten Promotionen und Exklusivangebote von Ursa Casino und den von unserem <a href="/brands" target="_blank">Netzwerk verwalteten Marken</a>. Wählen Sie, wie Sie von uns informiert werden möchten.',
  'marketing-preferences-unified-label-email': 'E-mail',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Telefon',
  'marketing-preferences-unified-label-phone-post': 'Post',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>24/7 Kundenbetreuung</li><li class='one-hundred-percent-secure'>100% Sicher</li><li class='usp-fast'>Schnelle & einfache Abhebungen</li></ul>",
  //Cashier
  continue: 'Spielen',
};
